"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectStructure = exports.projectStructures = void 0;
exports.projectStructures = {
    lsc: {
        fwRelativeBase: '../i301',
        uipath: './UI',
    },
    p001: {
        fwRelativeBase: '../p001',
        uipath: './UI',
    },
    // the IoTV demonstration environment
    iotv: {
        fwRelativeBase: '../i301',
        uipath: './UI',
    },
    i3012: {
        fwRelativeBase: '../i301',
        uipath: './UI',
    },
    c021: {
        fwRelativeBase: '../c021',
        uipath: './UI',
    },
    c0212: {
        fwRelativeBase: '../c021',
        uipath: './UI',
    },
    ssac: {
        fwRelativeBase: '../ssac',
        uipath: './UI',
    },
    v010: {
        fwRelativeBase: '../v010',
        uipath: './UI',
    },
    v001: {
        fwRelativeBase: '../v001',
        uipath: './UI',
    },
    v0012: {
        fwRelativeBase: '../v001',
        uipath: './UI',
    },
    v015: {
        fwRelativeBase: '../v015',
        uipath: './UI',
    },
    v0132: {
        fwRelativeBase: '../i301',
        uipath: './UI',
    },
    v0152: {
        fwRelativeBase: '../v015',
        uipath: './UI',
    },
    v0162: {
        fwRelativeBase: '../v016',
        uipath: './UI',
    },
    v0163: {
        fwRelativeBase: '../v016',
        uipath: './UI',
    },
    n016: {
        fwRelativeBase: '../v016',
        uipath: './UISiloSure',
    },
    v0172: {
        fwRelativeBase: '../v017',
        uipath: './UI',
    },
    v017: {
        fwRelativeBase: '../v017',
        uipath: './UI',
    },
    v020: {
        fwRelativeBase: '../v020',
        uipath: './UI',
    },
    v0202: {
        fwRelativeBase: '../v020',
        uipath: './UI',
    },
    v021: {
        fwRelativeBase: '../v021',
        uipath: './UI'
    },
    v022: {
        fwRelativeBase: '../v022',
        uipath: './UI',
    },
    v023: {
        fwRelativeBase: '../v023',
        uipath: './UI',
    },
    v024: {
        fwRelativeBase: '../v024',
        uipath: './UI',
    },
};
const getProjectStructure = (projectCode) => {
    return exports.projectStructures[projectCode] ?? exports.projectStructures.lsc;
};
exports.getProjectStructure = getProjectStructure;
